<template>
  <div ref="layout" class="page-form">

    <h3 class="title">货权转移申请单审批</h3>

    <div class="form-container">
      <div class="tools">
        <form-button style="margin-right:10px" @click="$router.go(-1)">返回</form-button>
        <btky-header
          :form-data="transferApplyPo"
          :process-key="processKey"
          @formDataSave="saveData"
          @validate="validate"
          @advanceSuccess="advanceSuccess"
        />
      </div>
      <common-title title="基本信息" />
      <el-form ref="form" inline size="mini" label-width="110px" :model="transferApplyPo" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="创建人" label-width="">
              <el-input
                v-model="transferApplyPo.createdByName"
                placeholder="请输入"
                type="text"
                name="transferApplyPo.createdByName"
                clearable
                readonly
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="创建日期" label-width="">
              <el-date-picker
                v-model="transferApplyPo.createdDate"
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                clearable
                readonly
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="接收客户" label-width="" prop="receiveClientCode">
              <el-input v-model="transferApplyPo.receiveClientCode" width="100px" suffix-icon="el-icon-more" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="货权接收客户名称" label-width="">
              <el-input
                v-model="transferApplyPo.receiveClient"
                readonly
                disabled
                width="100px"
              />

            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="转移明细" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #planType="{ row }">
            <span>{{ filterDictionary(row.planType, 'A0002') }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon
        title="附件"
        :custome-config="() => vxeShowCustom('xTable3')"
      >
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="medium"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions2.columns"
          :data="gridOptions2.data"
        >
          <template #fileName="{row}">
            <span class="blue" @click="dowLoadFile(row)">{{ row.fileName }}</span>
          </template>
          <template #createdDate="{row}">
            <span>{{ row.createdDate || row.creator.createdDate }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <btky-footer :form-data="transferApplyPo" />
    </div>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { handlerFlow } from '@/api/flowHander'
import { filterDictionary } from '@/utils/index'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { queryFiles, apiAttachmentDownFile } from '@/api/common'
import { download } from '@/utils/frontExport'
import { transfergoodsrightsFindById } from '@/api/applyForGoods/index'

export default {
  name: 'TransferApprove',
  data() {
    const rules = {
      invoiceNo: [{ required: false, message: '请选择制票通知单', trigger: 'change' }],
      planType: [{ required: false, message: '请选择计划类型', trigger: 'change' }],
      planYear: [{ required: false, message: '请选择计划年度', trigger: 'change' }],
      receiveClient: [{ required: true, message: '请选择货权接收客户', trigger: 'change' }],
      thisTransferQuantity: [{ required: true, message: '请填写本次转移量', trigger: 'blur' }]
    }
    return {
      rules: rules,
      processKey: 'transfergoodsrights',
      selectDataOptions: {},
      transferApplyPo: {
        id: '',
        taskId: '',
        bizId: '',
        status: 0,
        billCode: '',
        billStatus: 'E001',
        deptId: '',
        deptName: '',
        endDate: '',
        expireDate: '',
        fillinDate: '',
        fullId: '',
        organId: '',
        organName: '',
        personMemberId: '',
        personMemberName: '',
        positionId: '',
        positionName: '',
        createdById: '',
        createdByName: '',
        createdDate: '',

        invoiceNo: '',
        transferClient: '',
        receiveClient: '',
        receiveClientCode: '',
        productCode: '',
        productDesc: '',
        invoiceQuantity: '',
        deliveryQuantity: '',
        transferedQuantity: '',
        thisTransferQuantity: '',
        planType: '',
        planYear: ''
      },
      gridOptions: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'planYear', title: '年度', width: 80 },
          { field: 'orderCust', title: '来源客户', width: 120 },
          { field: 'orderCustName', title: '来源客户名称', width: 200 },
          { field: 'planType', title: '计划类型', width: 120, slots: { default: 'planType' }},
          { field: 'productDesc', title: '产品名称', width: 200 },
          { field: 'transferedQuantity', title: '已转移量', width: 100 },
          { field: 'surplusQty', title: '剩余量', width: 100 },
          { field: 'thisTransferQuantity', title: '本次货权转移量', width: 120 },
          { field: 'comment', title: '备注', width: 120 }
        ],
        data: []
      },
      gridOptions2: {
        columns: [
          { type: 'seq', title: '序号', filed: 'seq', width: 50 },
          {
            field: 'fileName',
            title: '附件名称',
            slots: {
              default: 'fileName'
            }
          },
          {
            field: 'fileKind',
            title: '附件类型'
          },
          {
            field: 'fileSize',
            title: '大小'
          },
          {
            field: 'createdDate',
            title: '上传时间',
            slots: {
              default: 'createdDate'
            }
          }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.getSelectDictDataOrigin('A0002')
    const { id } = this.$route.query
    if (id) {
      this.transferApplyPo.id = id
      this.transfergoodsrightsFindById()
    }
  },
  methods: {
    filterDictionary,
    async transfergoodsrightsFindById() {
      const res = await transfergoodsrightsFindById({ id: this.transferApplyPo.id })
      Object.assign(this.transferApplyPo, res.data)
      this.transferApplyPo.bizId = res.data.id
      this.transferApplyPo.planYear = res.data.planYear + ''
      this.gridOptions2.data = this.transferApplyPo.attachmentList
      this.gridOptions.data = this.transferApplyPo.transferProductDtlList
      this.transferApplyPo.taskId = this.$route.query.taskId
      this.getFiles()
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    async getFiles() {
      const params = {
        bizId: this.transferApplyPo.id,
        bizCode: this.processKey
      }
      const { data } = await queryFiles(params)
      this.gridOptions2.data = data
    },
    async dowLoadFile({ id, fileName }) {
      const res = await apiAttachmentDownFile({ id })
      download(res.data, fileName)
    },
    validate(cb) {
      this.$refs.form.validate(valid => {
        if (valid) {
          cb && cb()
        } else {
          return false
        }
      })
    },
    saveData() {
      this.loading = true
      this.transferApplyPo.attachmentList = this.gridOptions2.data
      const params = JSON.parse(JSON.stringify(this.transferApplyPo))
      console.log(this.transferApplyPo)
      console.log(this.transferApplyPo.attachmentList)
      handlerFlow(params, this.processKey)
        .then(response => {
          this.loading = false
          // alert(response.data.bizId)
          if (!this.transferApplyPo.id) {
            this.id = response.data.bizId
            this.transferApplyPo.id = response.data.bizId
            this.transferApplyPo.bizId = response.data.bizId
            this.transferApplyPo.taskId = response.data.taskId
            this.transferApplyPo.procInstId = response.data.bizprocInstId
            this.transferApplyPo.billCode = response.data.bizData.billCode
            this.transferApplyPo.billStatus = response.data.bizData.billStatus
            this.transferApplyPo.createdByName = response.data.bizData.createdByName
          }
          this.$message.success('保存成功')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 提交成功
    advanceSuccess(id) {
      if (id) {
        this.id = id
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/TransferApprove.vue